import { useTheme } from '@mui/material';
import update from 'immutability-helper';
import { useState } from 'react';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Card } from './Card';
import { ReorderListItem } from "./ReorderListItem";

interface IProps {
    items: ReorderListItem[];
    onChangeOrder: (cards: ReorderListItem[]) => void;
    onCanMove?: (cards: ReorderListItem[], dragIndex: number, hoverIndex: number) => boolean;
}

export const MprcReorderList = ({ items, onCanMove, onChangeOrder }: IProps) => {
    const [cards, setCards] = useState(items);
    const theme = useTheme();

    const moveCard = (dragIndex: number, hoverIndex: number) => {
        const canMove = onCanMove ? onCanMove(cards, dragIndex, hoverIndex) : true;
        if (canMove) {
            setCards((prevCards: ReorderListItem[]) =>
                update(prevCards, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, prevCards[dragIndex] as ReorderListItem],
                    ],
                })
            );
            return true;
        }
        return false;
    };

    const renderCard = (card: ReorderListItem, index: number) => {
        return (
            <Card
                key={card.id}
                index={index}
                id={card.id}
                text={card.text}
                boxColor={card.cardColor ? theme.palette[card.cardColor].main : undefined}
                textColor={card.cardColor ? theme.palette.getContrastText(theme.palette[card.cardColor].main) : undefined}
                moveCard={moveCard}
                dropCard={() => onChangeOrder(cards)}
            />
        );
    };

    return (
        <DndProvider backend={HTML5Backend}>
            {cards.map((card, i) => renderCard(card, i))}
        </DndProvider>
    );
};
